import { Prognosis } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/Prognosis";
import { FC } from "react";
import { Stack } from "shared/components/Spor";
import { TimedOrOpenEndedDuration } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/subTypeInputs/TimedOrOpenEndedDuration";

export const CustomInfrastructureEvent: FC = () => (
  <Stack gap="12px">
    <TimedOrOpenEndedDuration />
    <Prognosis formPrefix="infrastructureForm" />
  </Stack>
);
